import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { AudienceRule } from './audience-rule'

export class AudienceRulesRepository extends BaseRepository<AudienceRule> {
    constructor(
        private endpoint: string,
        config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        if (!endpoint) throw new Error('Constructor param required')

        super(config.eventApiUrl + '/' + endpoint, token, cache)
    }
}
